import {apiLink, apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {OfferOpinionsStatsResponse, PostOfferOpinionsRequest, PostPropertyOpinionsRequest} from "../types/IOfferOpinions";

export const userOpinionsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserOpinionsOffer: builder.query<OfferOpinionsStatsResponse, {offerId: number}>({
            query: (arg) => {
                return {
                    url: apiV2Link.opinions.offer_stats({offerId: arg.offerId}),
                    method: "GET"
                };
            }
        }),
        getUserOpinionsProperty: builder.query<OfferOpinionsStatsResponse, {propertyId: number}>({
            query: (arg) => {
                return {
                    url: apiV2Link.opinions.property_stats({propertyId: arg.propertyId}),
                    method: "GET"
                };
            }
        }),
        postUserOpinions: builder.mutation<null, PostOfferOpinionsRequest | PostPropertyOpinionsRequest>({
            query: (body) => {
                return {
                    url: apiLink.opinions.create({})(null),
                    method: "POST",
                    body
                };
            }
        })
    })
});

export const {useLazyGetUserOpinionsOfferQuery, useLazyGetUserOpinionsPropertyQuery, usePostUserOpinionsMutation} = userOpinionsApi;
import {apiLink, apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {OfferOpinionsStatsResponse, PostOfferOpinionsRequest, PostPropertyOpinionsRequest} from "../types/IOfferOpinions";

export const userOpinionsApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserOpinionsOffer: builder.query<OfferOpinionsStatsResponse, {offerId: number}>({
            query: (arg) => {
                return {
                    url: apiV2Link.opinions.offer_stats({offerId: arg.offerId}),
                    method: "GET"
                };
            }
        }),
        getUserOpinionsProperty: builder.query<OfferOpinionsStatsResponse, {propertyId: number}>({
            query: (arg) => {
                return {
                    url: apiV2Link.opinions.property_stats({propertyId: arg.propertyId}),
                    method: "GET"
                };
            }
        }),
        postUserOpinions: builder.mutation<null, PostOfferOpinionsRequest | PostPropertyOpinionsRequest>({
            query: (body) => {
                return {
                    url: apiLink.opinions.create({})(null),
                    method: "POST",
                    body
                };
            }
        })
    })
});

export const {useLazyGetUserOpinionsOfferQuery, useLazyGetUserOpinionsPropertyQuery, usePostUserOpinionsMutation} = userOpinionsApi;
